import { render, staticRenderFns } from "./EmbarquePermitido.vue?vue&type=template&id=ad8f7716&"
import script from "./EmbarquePermitido.vue?vue&type=script&lang=js&"
export * from "./EmbarquePermitido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports